import React from 'react';
import { Badge, Typography } from 'seagull';
import styles from "./RecipientDetails.module.scss";
const RecipientDetails = _ref => {
  let {
    email,
    lastName,
    firstName,
    companyName,
    badge,
    testid = 'recipient-details'
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.recipientDetails,
    "data-testid": testid
  }, /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "".concat(testid, "-text")
  }, "".concat(firstName || '', " ").concat(lastName || '').concat(companyName ? " (".concat(companyName, ")") : '', ", ").concat(email)), badge === 'required' && /*#__PURE__*/React.createElement(Badge, {
    rounded: true,
    outlined: true
  }, /*#__PURE__*/React.createElement(Typography, {
    skin: "disabled",
    variant: "paragraph2",
    "data-testid": "".concat(testid, "-required-badge-text")
  }, "Required to sign")), badge === 'signed' && /*#__PURE__*/React.createElement(Badge, {
    rounded: true,
    outlined: true,
    skin: "success"
  }, /*#__PURE__*/React.createElement(Typography, {
    skin: "success",
    variant: "paragraph2",
    "data-testid": "".concat(testid, "-signed-badge-text")
  }, "Signed")));
};
export default RecipientDetails;